// Images from the CDN: every file in public/images is also in the R2 bucket `suvaani` under the same key
// (images/dhatu/bhana.jpg), served at cdn.suvaani.app and resized there by Cloudflare Image Transformations
// (/cdn-cgi/image/…, format=auto picks AVIF or WebP). In production next.config.ts makes this the next/image loader,
// which also switches off /_next/image, so share images and icons use cdnImage() too. A new picture in public/images
// must be uploaded to the bucket as well, or production shows it broken.

export const CDN_ORIGIN = (process.env.NEXT_PUBLIC_CDN_URL || 'https://cdn.suvaani.app').replace(/\/+$/, '')

/**
 * A public/images file (`/images/…`) at `width` pixels from the CDN; any other address is returned unchanged. `auto`
 * lets the browser get AVIF or WebP; `original` keeps the file's own PNG or JPEG, for icons and share images, which
 * home screens and link previews may not read in AVIF.
 */
export const cdnImage = (src: string, width: number, quality = 75, format: 'auto' | 'original' = 'auto'): string => {
    if (!src.startsWith('/images/')) return src

    return `${CDN_ORIGIN}/cdn-cgi/image/width=${width},quality=${quality}${format === 'auto' ? ',format=auto' : ''}${src}`
}

interface LoaderProps {
    src: string
    width: number
    quality?: number
}

const imageLoader = ({ src, width, quality }: LoaderProps): string => cdnImage(src, width, quality)

export default imageLoader
